import React from "react";

import { useGetSegmentBySegmentIdQuery } from "@tiny/api";
import {
  useRefreshRegister,
  useRefresh,
} from "@tiny/components/src/RefreshProvider";
import { format } from "date-fns";

const DATE_FORMAT = "d MMM, yy - h:mm aa";

export function useAudienceSourceDetails(segmentIdProp?: string) {
  const { refresh } = useRefresh();

  const { segmentId } = useAudienceSourceDetailsParams(segmentIdProp);

  const {
    data: segmentDetails,
    refetch: refetchSegmentDetails,
    isLoading: isSegmentLoading,
  } = useGetSegmentBySegmentIdQuery(segmentId);

  useRefreshRegister(async () => {
    await refetchSegmentDetails();
  });

  const enableEdit = React.useMemo(() => {
    return !isSegmentLoading && segmentDetails?.segmentType !== "INTEGRATION";
  }, [isSegmentLoading, segmentDetails?.segmentType]);

  const subtitle = React.useMemo(() => {
    if (!segmentDetails?.createdAt) {
      return null;
    }
    const formattedDate = format(
      new Date(segmentDetails?.createdAt),
      DATE_FORMAT
    );
    return `Created: ${formattedDate}`;
  }, [segmentDetails?.createdAt]);

  return {
    segmentDetails,
    segmentId,
    refetchSegmentDetails,
    enableEdit,
    subtitle,
    isSegmentLoading,
  };
}

function useAudienceSourceDetailsParams(segmentIdProp?: string) {
  // segmentId arrives via props from the app's route layer.
  const segmentId = segmentIdProp;

  return {
    segmentId: segmentId!,
  };
}
